/* ============================================
   SelectorContactoEmpresa — elige un contacto vinculado a la empresa.
   Fuente de verdad: la relación contacto_empresa (embebida en Cliente.contactos).
   Reemplaza el autocompletado desde las columnas planas de `clientes`.
   ============================================ */

import type { ContactoVinculado } from '@/lib/types'

export function nombreContacto(ct: ContactoVinculado): string {
  return [ct.nombre, ct.apellido].filter(Boolean).join(' ')
}

function etiqueta(ct: ContactoVinculado): string {
  const roles = ct.roles?.length ? ct.roles.join(', ') : (ct.es_principal ? 'PRINCIPAL' : '')
  return `${nombreContacto(ct)}${roles ? ` — ${roles}` : ''}${ct.email ? ` · ${ct.email}` : ''}`
}

export default function SelectorContactoEmpresa({
  contactos,
  value,
  onSelect,
}: {
  contactos: ContactoVinculado[]
  value: number | null
  onSelect: (ct: ContactoVinculado | null) => void
}) {
  if (contactos.length === 0) {
    return (
      <p style={{ margin: 0, fontSize: '0.82rem', color: 'var(--text-muted)' }}>
        Esta empresa no tiene contactos. Agrégalos en Contactos para poder elegir uno.
      </p>
    )
  }
  return (
    <select
      className="form-select"
      value={value ?? ''}
      onChange={e => onSelect(contactos.find(c => c.id === Number(e.target.value)) ?? null)}
    >
      {contactos.map(ct => (
        <option key={ct.id} value={ct.id}>{etiqueta(ct)}</option>
      ))}
    </select>
  )
}
